import { FC } from 'react';
import CouponCard from '../../../../../../components/CouponCard/CouponCard';
import { IOrganizationCoupon } from '../../../../../../types/coupons.types';
import './UsedCoupons.scss';

interface IUsedCouponsProps {
  usedCoupons: IOrganizationCoupon[];
}

/**
 * Componente que muestra los cupones que ya han sido utilizados por la organización
 * @param {Object} props - Propiedades del componente
 * @param {IOrganizationCoupon[]} props.usedCoupons - Lista de cupones utilizados
 * @returns {JSX.Element} - Componente de cupones utilizados
 */
const UsedCoupons: FC<IUsedCouponsProps> = ({ usedCoupons }: IUsedCouponsProps) => {
  if (!usedCoupons || !usedCoupons.length) return <></>;

  return (
    <div className="usedCouponsContainer">
      <div className="usedCouponsTitle">Historial de cupones usados</div>
      <div className="usedCouponsList">
        {usedCoupons?.map(coupon => (
          <CouponCard key={coupon?.id} couponData={coupon} />
        ))}
      </div>
    </div>
  );
};

export default UsedCoupons;
